export default {
  toast: {
    show: false,
    message: '',
    color: '',
  },
  errorDataUnauthorizedAccess: false,
  errorDataMissing: false,
  nodeCurrent: {
    workspace: {
      id: '',
      name: '',
    },
    master: {
      id: '',
      title: '',
    },
    instance: {
      id: '',
      title: '',
    },
  },
  userLogged: {
    logged: false,
    id: '',
    email: '',
    token: null,
    crc: '',
    usageLimits: {},
    actionsAllowed: {},
  },
  userTimePreference: 'locale',
}
